// @flow

import { MOUNT_POINT } from './constants';
import type { Breadcrumb, State } from './reducer';

const getBreadcrumbs = (state: State): Array<Breadcrumb> => state[MOUNT_POINT];

export default getBreadcrumbs;
